import Box from '@mui/material/Box';
import { CategoryForm, CategoryFormProps } from 'kes-common';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import SidePopup from '@/components/SidePopup';
import { application } from '@/routes';
import { studyId as studyIdSelector } from '@/selectors';
import { categoryPersist } from '@/store/actions';

const CategoryCreate: React.FC = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const studyId = useSelector(studyIdSelector);
	const { enqueueSnackbar } = useSnackbar();

	const onSubmit = React.useCallback<CategoryFormProps['onSubmit']>(
		async (category) => {
			dispatch(categoryPersist({ category }));
			history.push(application({ applicationName: studyId }));
			enqueueSnackbar(`Category '${category.name}' created successfully`);
		},
		[dispatch, enqueueSnackbar, history, studyId],
	);

	return (
		<Box sx={{ bottom: 0, left: 0, position: 'absolute', right: 500, top: 0, width: 500 }}>
			<SidePopup title="Create Category">
				<CategoryForm
					l10n={{
						actionPrimary: 'Create category',
						fieldInformationHelperText:
							'Informatory text to display at the beginning of the category',
						fieldInformationLabel: 'Information',
						fieldNameErrorRequired: 'Please fill in a name for the Category',
						fieldNameHelperText: 'The name of the category',
						fieldNameLabel: 'Category name',
					}}
					onSubmit={onSubmit}
				/>
			</SidePopup>
		</Box>
	);
};

export default CategoryCreate;
